import { createFileRoute } from '@tanstack/react-router'

import sourceRaw from '#/content/support/privacy-policy.md?raw'
import sourceUrl from '#/content/support/privacy-policy.md?url'
import { Article } from './-components/Article.js'

/** Route for Tempo's Privacy Policy. */
export const Route = createFileRoute('/support/privacy-policy')({
  component: PrivacyPolicyPage,
  // Server reads the bundled markdown directly (no client-side bundle cost
  // because the `?raw` import is tree-shaken via `import.meta.env.SSR`).
  // Client fetches the hashed `.md` static asset; the loader fires when the
  // route matches, in parallel with mount and (when preloaded) chunk download.
  loader: async () => {
    if (import.meta.env.SSR) return sourceRaw
    const response = await fetch(sourceUrl)
    if (!response.ok) throw new Error(`Failed to load Privacy Policy (${response.status})`)
    return response.text()
  },
  head: () => ({
    links: [{ href: 'https://wallet.tempo.xyz/support/privacy-policy', rel: 'canonical' }],
    meta: [
      { title: 'Privacy Policy | Tempo Wallet' },
      { content: 'Privacy Policy for Tempo.', name: 'description' },
    ],
  }),
})

function PrivacyPolicyPage() {
  return <Article slug="privacy-policy" source={Route.useLoaderData()} />
}
